import "./stats.css"
import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Chart from "react-apexcharts"
import { FaLock, FaCalendarAlt } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import AdminService from "../../../services/admin_services"

const d = new Date();


class AdminStatSafes extends Component {
    constructor(props) {
        super(props)
        this.state = {
            safes_daily_stats: {},
            safes_stats: {},
            end_date: new Date().toISOString().substring(0, 10),
            start_date: new Date(d.setMonth(new Date().getMonth() - 1)).toISOString().substring(0, 10),
            options_safes: null,
            series_star: null,
        }
    }

    componentDidMount = async () => {
        await this.loadStats()
    }

    loadStats = async () => {
        const safes = await AdminService.getSafesUsage(this.state.start_date, this.state.end_date)
        const nb_deleted = [], nb_opened = [], nb_safes = [], nb_stars = []
        Object.keys(safes.daily_stats).map(key => nb_deleted.push(safes.daily_stats[key].nb_deleted))
        Object.keys(safes.daily_stats).map(key => nb_opened.push(safes.daily_stats[key].nb_opened))
        Object.keys(safes.daily_stats).map(key => nb_safes.push(safes.daily_stats[key].nb_safes))
        Object.keys(safes.daily_stats).map(key => nb_stars.push(safes.daily_stats[key].nb_stars))
        this.setState({
            safes_daily_stats: safes.daily_stats,
            safes_stats: safes.safes_stats,
            options_safes: { chart: { id: "safes-bar" }, xaxis: { categories: Object.keys(safes.daily_stats) } },
            nb_deleted: [{ name: "safes", data: nb_deleted }],
            nb_opened: [{ name: "safes", data: nb_opened }],
            nb_safes: [{ name: "safes", data: nb_safes }],
            nb_stars: [{ name: "safes", data: nb_stars }]
        })
    }

    render() {
        return (
            <AdminLayout 
                title="Safes Statistics"
                breadcrumbs={[
                    { label: 'Statistics', href: '/admin/stats' },
                    { label: 'Safes' }
                ]}
            >
                <div className="space-y-6">
                    {/* Header with Date Range */}
                    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                        <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                            <FaLock className="text-emerald-600" />
                            Safes Statistics
                        </h3>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                                    <FaCalendarAlt className="text-gray-500" />
                                    Start Date
                                </label>
                                <input 
                                    type="date" 
                                    defaultValue={this.state.start_date} 
                                    onChange={(e) => this.setState({ start_date: e.target.value }, () => this.loadStats())}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent outline-none"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                                    <FaCalendarAlt className="text-gray-500" />
                                    End Date
                                </label>
                                <input 
                                    type="date" 
                                    defaultValue={this.state.end_date} 
                                    onChange={(e) => this.setState({ end_date: e.target.value }, () => this.loadStats())}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent outline-none"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Stats Table */}
                    <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                        <div className="bg-gradient-to-r from-emerald-50 to-green-50 px-6 py-3 border-b border-gray-200">
                            <h4 className="font-semibold text-gray-900">Safe Statistics Overview</h4>
                        </div>
                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead className="bg-gray-50 border-b border-gray-200">
                                    <tr>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Delay by safe</th>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Delay by star</th>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Deleted rate</th>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Nb safes</th>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Safes opened by day</th>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Safes win by day</th>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Coins by safe</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="border-b border-gray-200">
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-gray-900">{this.state.safes_stats.delay_by_safe}</span></td>
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-gray-900">{this.state.safes_stats.delay_by_star}</span></td>
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-red-600">{this.state.safes_stats.deleted_rate}</span></td>
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-emerald-600">{this.state.safes_stats.nb_safes}</span></td>
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-gray-900">{this.state.safes_stats.safes_opened_by_day}</span></td>
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-emerald-600">{this.state.safes_stats.safes_win_by_day}</span></td>
                                        <td className="px-4 py-4 text-center"><span className="text-lg font-bold text-amber-600">{this.state.safes_stats.stars_by_safe}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Charts */}
                    <div className="grid grid-cols-1 gap-6">
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h4 className="text-lg font-semibold text-gray-900 mb-4">Deleted Safes</h4>
                            {this.state.nb_deleted && <Chart options={this.state.options_safes} series={this.state.nb_deleted} type="bar" />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h4 className="text-lg font-semibold text-gray-900 mb-4">Opened Safes</h4>
                            {this.state.nb_opened && <Chart options={this.state.options_safes} series={this.state.nb_opened} type="bar" />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h4 className="text-lg font-semibold text-gray-900 mb-4">Number of Safes</h4>
                            {this.state.nb_safes && <Chart options={this.state.options_safes} series={this.state.nb_safes} type="bar" />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h4 className="text-lg font-semibold text-gray-900 mb-4">Number of Stars</h4>
                            {this.state.nb_stars && <Chart options={this.state.options_safes} series={this.state.nb_stars} type="bar" />}
                        </div>
                    </div>
                </div>
            </AdminLayout>
        )
    }
}

export default withTranslation()(AdminStatSafes)